import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { __i18n } from '@localisation';

@Injectable()
export class M2MInformationItemNameTranslationService {
    private names: object = {
        customerOrderNumber: __i18n('Customer order number', 'm2m.informationitemname.customerordernumber'),
        simProfile: __i18n('SIM profile', 'm2m.informationitemname.simprofile'),
        ragStatus: __i18n('RAG status', 'm2m.informationitemname.ragstatus'),
        provisioningStatus: __i18n('Provisioning status', 'm2m.informationitemname.provisioningstatus'),
        provisionedAtTimestamp: __i18n('Provisioned at', 'm2m.informationitemname.provisionedat'),
        lastChangeTimestamp: __i18n('Last change', 'm2m.informationitemname.lastchange'),
        firstUsedTimestamp: __i18n('First used', 'm2m.informationitemname.firstused'),
        iccid: __i18n('Iccid', 'm2m.informationitemname.iccid'),
        targetState: __i18n('Target state', 'm2m.informationitemname.targetstate'),
        startedActiveTest: __i18n('Started active test', 'm2m.informationitemname.startedactivetest'),
        hasBeenActiveTest: __i18n('Has been active test', 'm2m.informationitemname.hasbeenactivetest'),
        hasBeenActiveLive: __i18n('Has been active live', 'm2m.informationitemname.hasbeenactivelive'),
        sessionActive: __i18n('Session active', 'm2m.informationitemname.sessionactive'),
        sessionLastIpAddress: __i18n('Session last IP address', 'm2m.informationitemname.sessionlastipaddress'),
        sessionLastStartedTimestamp: __i18n('Session last started', 'm2m.informationitemname.sessionlaststarted'),
        sessionLastUpdatedTimestamp: __i18n('Session last updated', 'm2m.informationitemname.sessionlastupdated'),
        sessionLastTerminatedTimestamp: __i18n('Session last terminated',
            'm2m.informationitemname.sessionlastterminated'),
        sessionLastDataTransmittedTimestamp: __i18n('Session last data transmitted',
            'm2m.informationitemname.sessionlastdatatransmitted'),
        sessionLastCellId: __i18n('Session last cell id', 'm2m.informationitemname.sessionlastcellid'),
        sessionBytesIn: __i18n('Session bytes in', 'm2m.informationitemname.sessionbytesin'),
        sessionBytesOut: __i18n('Session bytes out', 'm2m.informationitemname.sessionbytesout'),
        sessionLastNotificationFailureTimestamp: __i18n('Session last notification failure',
            'm2m.informationitemname.sessionlastnotificationfailure'),
        sessionLastNotificationFailureReason: __i18n('Session last notification failure reason',
            'm2m.informationitemname.sessionlastnotificationfailurereason'),
        sessionPreviousNormalTimestamp: __i18n('Session previous normal',
            'm2m.informationitemname.sessionpreviousnormal'),
        sessionLastAuthFailureTimestamp: __i18n('Session last authentication failure',
            'm2m.informationitemname.sessionlastauthfailure'),
        sessionLastAuthFailureReason: __i18n('Session last authentication failure reason',
            'm2m.informationitemname.sessionlastauthfailurereason'),
        lastWakeupRequestTimestamp: __i18n('Last wakeup request', 'm2m.informationitemname.lastwakeuprequest'),
        lastWakeupRequestType: __i18n('Last wakeup request type', 'm2m.informationitemname.lastwakeuprequesttype'),
        lastDetectedImei: __i18n('Last detected IMEI', 'm2m.informationitemname.lastdetectedimei'),
        lastDetectedImeiTimestamp: __i18n('Last detected IMEI timestamp',
            'm2m.informationitemname.lastdetectedimeitimestamp'),
    };

    public getLocalizedInformationItemName(name: string): string {
        return this.names[name] || name;
    }
}

@Pipe({
    name: 'translateM2MInformationItemName',
    standalone: false
})
@Injectable()
export class TranslateM2MInformationItemNamePipe implements PipeTransform {
    constructor(
        private m2MInformationItemNameTranslationService: M2MInformationItemNameTranslationService) {
            // Nothing to do here.
        }

    public transform(value: string): string {
        return this.m2MInformationItemNameTranslationService.getLocalizedInformationItemName(value);
    }
}

export function m2MInformationItemNameTranslationsFactory() {
    return new M2MInformationItemNameTranslationService();
}

export const M2MInformationItemNameTranslationsProvider = {
    provide: M2MInformationItemNameTranslationService,
    useFactory: m2MInformationItemNameTranslationsFactory,
    deps: []
};
